module.exports = __webpack_public_path__ + "img/teams.265ad561.svg";